// extracted by mini-css-extract-plugin
export default {"item":"UserDetailForm_item__LUQRh","notes":"UserDetailForm_notes__46D27","link":"UserDetailForm_link__IvxNn","input":"UserDetailForm_input__i5sCC"};